import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Kyanpeen from "../../img/kyanppen.png";

const Main = styled.div`
    margin-top: 50px;
    background: whitesmoke;
    text-align: center;
`;
const MainClass = styled.div`
    margin-top: 50px;
    background: white;
    text-align: center;
`;
const Iframe = styled.iframe`
  width: 100%;
  height: 320px;
  margin: 30px auto;
`;

const Manseki = styled.span`
  color: red;
`;


const SvgTel = <svg class="h-6 w-6 text-orange-500 inline"  fill="none" viewBox="0 0 24 24" stroke="currentColor">
<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
</svg>

export default function Introduction() {
  const url ='/STEMON/';

  // 2026年1月16日 13:00:00以降に表示する設定
  const targetDate = new Date(2026, 0, 16, 13, 0, 0);
  const currentDate = new Date();
  const showCampaign = currentDate >= targetDate;

  return (
  <>
    {showCampaign && (
    <Main>
      
      {/* <h3 className='pt-5 font-bold text-xl py-3'>「体験会」のご案内</h3>
      <p className='text-2xl text-pink-500 font-bold'>春の入学&進級応援キャンペーン</p>
      <p className='text-4xl text-red-600 font-extrabold py-2'>入会金無料</p> */}
      {/* <h3 className='mt-5 p-5 text-blue-400 text-2xl'><span className='text-blue'>体験レッスンをご希望の方はお問い合わせください</span></h3> */}
      {/* <p className='text-2xl text-black'>「<span className="text-3xl text-blue-800 font-extrabold px-2">夜寄る体験レッスン</span> inステモン高知 」</p> */}
      {/* <p className="w-3/4 mx-auto mt-5 text-xl text-black">
        「日曜日はなかなか行けない」「仕事帰りに時間に体験レッスンがあればいいな」そんな保護者様の為に今回初めて平日の夕方に無料体験レッスンを行います！
ぜひこの機会にお申込みください。
      </p> */}
      {/* <h3 className='mt-5 p-5 text-blue-400 text-2xl'><span className='text-black'>※体験会の申込は終了いたしました</span></h3> */}
      {/* <h3 className='mt-5 text-blue-400 text-2xl'><span className='text-black'>STEMON秦校:</span>&nbsp;3/9(日)</h3> */}
      {/* <h3 className='mt-5 text-blue-400 text-2xl'><span className='text-black'>STEMON旭校:</span>&nbsp;4/21(日)</h3> */}
      <div className='mt-5'>
        {/* <p className='mt-2'>内容：ブロック制作を通した物理レッスン</p>  
        <p className='mt-2'>：プログラミング入門</p>  
        <p className='text-xl mt-4 mb-2 font-bold'>体験レッスン日: 2/8(日)</p>
        <div className='grid grid-cols-2 gap-x-4 w-fit mx-auto text-left'>
          <p className='mt-2 font-semibold'>新年中・新年長:</p>
          <p className='mt-2'>10:30-11:10<br/>13:30-14:10</p>
          <p className='mt-2 font-semibold'>新小1~新小4:</p>
          <p className='mt-2'>11:30-12:10<br/>14:30-15:10</p>
        </div>
        <p className='text-sm mt-4 px-4 pb-5'>
          ※2026年2月1日~3月31日の期間に体験にご参加いただき、 体験から7日以内にご入会お申込みの上、2026年4月よりレッスンを受講される方が対象となります!
        </p> */}

        <button className='mt-5 mb-5 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded text-2xl'>
          <a href="https://www.stemon.net/schools/kochihada/">
          体験会の申し込みはこちら
          </a> 
        </button>
        <div class="m-auto w-[90%]">
          <img src={Kyanpeen} alt="" className="m-auto"  />
        </div>
  
      </div>
    </Main>
    )}
    <MainClass>
      <div className='mt-3 '>
        {/* <div className='col-span-3 rounded border-solid border p-5'>
          <p className='font-bold text-3xl'>STEMONイオン高知旭町校</p>
          <div><Iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d988.4989104757709!2d133.5049928543817!3d33.55595464303343!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x354e18f29a9a02bb%3A0x5621c0793836db59!2z44Kk44Kq44Oz6auY55-l5pet55S65bqX!5e0!3m2!1sja!2sjp!4v1646988993749!5m2!1sja!2sjp" loading="lazy"></Iframe></div>
          <p className='font-bold'>高知県高知市旭町3丁目94</p>
          <p className='font-bold'>{SvgTel}&ensp;088-802-5651</p>
        </div> */}
        <div className='col-span-3 rounded border-solid border p-5'>
          <p className='font-bold text-3xl'>STEMON秦校</p>
          <div><Iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1397.612801265094!2d133.53316088224463!3d33.57669630042055!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xe88c9bd963cde09f!2z44K544OG44Oi44Oz56em5qCh!5e0!3m2!1sja!2sjp!4v1646983051220!5m2!1sja!2sjp"  loading="lazy"></Iframe></div>
          <p className='font-bold'>高知市西秦泉寺73-1ソワール西秦I</p>
          <p className='font-bold'>{SvgTel}&ensp; 088-802-8739</p>
        </div>
      </div>
    </MainClass>
  </>
  );
}